<template>
    <body style="direction: rtl; text-align: right; padding-top: 70px;">
      <Header pageTitle=" المستقل" />
      <div v-if="isLoading" class="loading-overlay">
        <div class="spinner"></div>
      </div>
      <div v-else>
        <div class="container">
          <!-- قسم بيانات المستقل (الملف الشخصي) -->
          <div class="row">
            <div class="col-md-2"></div>
            <div class="col-md-8">
              <div class="card">
                <div
                  class="h-100px rounded-top"
                  style="background-color: #296080; background-position: center; background-size: cover; background-repeat: no-repeat;">
                </div>
                <div class="card-body py-0">
                  <div class="d-sm-flex align-items-start text-center text-sm-start">
                    <div>
                      <div class="avatar avatar-xxl mt-n5 mb-3">
                        <img
                          v-if="userData && userData.users_image"
                          class="avatar-img rounded-circle border border-white border-3"
                          :src="userData.users_image ? `https://zadcodeonline.com/ahmad/etqan/backEnd/upload/profile/${userData.users_image}` : 'assets/images/avatar/default-avatar.jpg'"
                          alt="صورة المستخدم" />
                        <img
                          v-else
                          class="avatar-img rounded-circle border border-white border-3"
                          src="/assets/person.png"
                          alt="صورة افتراضية" />
                      </div>
                    </div>
                    <div class="ms-sm-4 mt-sm-3">
                      <p class="mb-0" style="color: #296080; font-size: x-large; font-weight: bold;">
                        {{ userData.users_name }}
                      </p>
                      <h3 class="mb-0 h5" style="color: #296080;">
                        {{ freelancerData.freelance_current_country }}
                      </h3>
                      <div class="d-flex align-items-end justify-content-center justify-content-sm-start">
                        <p class="mb-0 me-2" style="font-weight: 900; color: #296080;">التقييم: </p>
                        <p class="mb-0 me-1 stars">
                          <i class="bi bi-star-fill text-warning"></i>
                          <i class="bi bi-star-fill text-warning"></i>
                          <i class="bi bi-star-fill text-warning"></i>
                          <i class="bi bi-star-half text-warning"></i>
                          <i class="bi bi-star text-warning"></i>
                        </p>
                      </div>
                      <div class="d-flex flex-wrap justify-content-center gap-2 mt-3">
                        <router-link style="border-radius: 10px;" to="#" class="btn btn-success d-flex align-items-center">
                          <i class="bi bi-telephone-fill me-1"></i> <span class="me-2">تواصل</span>
                        </router-link>
                        <router-link style="border-radius: 10px;" to="#" class="btn btn-primary d-flex align-items-center">
                          <i class="bi bi-briefcase-fill me-1"></i> <span class="me-2">عرض الأعمال</span>
                        </router-link>
                        <router-link style="border-radius: 10px;" to="/request-service" class="btn btn-info d-flex align-items-center text-white">
                          <i class="bi bi-file-earmark-fill me-1"></i> <span class="me-2">طلب خدمة</span>
                        </router-link>
                        <router-link style="border-radius: 10px;" to="#" class="btn btn-secondary d-flex align-items-center">
                          <i class="bi bi-send-fill me-1"></i> <span class="me-2">إرسال رسالة</span>
                        </router-link>
                      </div>
                    </div>
  
                    <div class="mt-3">
                      <div class="d-flex justify-content-start ms-sm-auto">
                        <p style="font-weight: 900; color: #296080;">نبذة عني:</p>
                      </div>
                      <div class="d-flex justify-content-end text-end ms-sm-auto">
                        <p style="color: #acacac;">
                          {{ freelancerData.freelance_personality }}
                        </p>
                      </div>
                    </div>
  
                    <div class="mt-3">
                      <div class="d-flex justify-content-start ms-sm-auto">
                        <p style="font-weight: 900; color: #296080;">المهنة:</p>
                      </div>
                      <div class="d-flex justify-content-end text-end ms-sm-auto">
                        <p style="font-weight: 500; color: #acacac;">
                          {{ freelancerData.freelance_competence }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-2"></div>
          </div>
  
          <!-- عنوان أعمال المستقل -->
          <div class="row">
            <div class="col-md-2"></div>
            <div class="col-md-8">
              <p style="font-weight: 900; color: #296080; margin-bottom: 0;">أعمال المستقل</p>
            </div>
            <div class="col-md-2"></div>
          </div>
  
          <!-- عرض أعمال المستقل على شكل كاردات -->
          <div class="row g-3">
            <div class="col-md-2"></div>
            <div class="col-md-8">
              <div class="row">
                <!-- لكل عمل في البورتفوليو -->
                <div
                  v-for="(item, index) in portfolio"
                  :key="index"
                  class="col-6 col-md-4 col-lg-3">
                  <div class="card">
                    <!-- عرض صورة العمل -->
                    <img
                      v-if="item.portfolio_image"
                      :src="`https://zadcodeonline.com/ahmad/etqan/backEnd/upload/portfolio_image/${item.portfolio_image}`"
                      class="card-img-top"
                      alt="Portfolio Image">
                    <!-- يمكنك تعديل الكود هنا إذا لم تتوفر صورة -->
                    <div class="card-body">
                      <!-- عنوان العمل -->
                      <h5 class="card-title">{{ item.portfolio_title }}</h5>
                      <!-- وصف مختصر للعمل -->
                      <p class="card-text">{{ item.portfolio_description }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-2"></div>
          </div>
  
          <!-- مؤشر التحميل عند نهاية الصفحة -->
          <div v-if="isLoadingMore" class="text-center mt-4">
            <div class="spinner-border" style="color: #296080;" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </body>
  </template>
  
  <script>
  import axios from 'axios';
  import Header from '../../components/header.vue';
  import Footer from '../../components/footer.vue';
  
  export default {
    name: 'IndependentsProfilePage',
    components: {
      Header,
      Footer,
    },
    data() {
      return {
        freelancerData: null,
        userData: null,
        portfolio: [],
        isLoading: true,
        limit: 3,
        offset: 0,
        isLoadingMore: false,
      };
    },
    mounted() {
      this.fetchFreelancerData();
      window.addEventListener('scroll', this.handleScroll);
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
      async fetchFreelancerData() {
        this.isLoading = true;
        const freelanceId = this.$route.params.id;
        try {
          const freelancerResponse = await axios.post(
            'https://zadcodeonline.com/ahmad/etqan/backEnd/profiles/view_freelancer.php',
            { usersid: freelanceId },
            { headers: { 'Content-Type': 'multipart/form-data' } }
          );
          if (freelancerResponse.data.status === 'success') {
            console.log('Freelancer data:', freelancerResponse.data.data);
            this.freelancerData = freelancerResponse.data.data;
            await this.fetchUserData(this.freelancerData.users_id);
            // جلب أعمال المستقل باستخدام usersid
            await this.fetchPortfolio(this.freelancerData.users_id);
          } else {
            console.error('Failed to fetch freelancer data.');
          }
        } catch (error) {
          console.error('Error fetching freelancer data:', error);
        } finally {
          this.isLoading = false;
        }
      },
      async fetchUserData(usersId) {
        try {
          const userResponse = await axios.post(
            'https://zadcodeonline.com/ahmad/etqan/backEnd/profiles/view.php',
            { usersid: usersId },
            { headers: { 'Content-Type': 'multipart/form-data' } }
          );
          if (userResponse.data.status === 'success') {
            console.log('User data:', userResponse.data.data);
            this.userData = userResponse.data.data;
          } else {
            console.error('Failed to fetch user data.');
          }
        } catch (error) {
          console.error('Error fetching user data:', error);
        }
      },
      async fetchPortfolio(usersId) {
        try {
          const portfolioResponse = await axios.post(
            'https://zadcodeonline.com/ahmad/etqan/backEnd/portfolio/view_portfolio.php',
            { usersid: usersId },
            { headers: { 'Content-Type': 'multipart/form-data' } }
          );
          if (portfolioResponse.data.status === 'success') {
            console.log('Portfolio data:', portfolioResponse.data.data);
            this.portfolio = portfolioResponse.data.data;
          } else {
            console.error('Failed to fetch portfolio data.');
          }
        } catch (error) {
          console.error('Error fetching portfolio data:', error);
        }
      },
      handleScroll() {
        // يمكنك هنا إضافة منطق التحميل عند التمرير (lazy loading أو pagination) إن رغبت
      },
    },
  };
  </script>
  
  <style scoped>
  .card,
  .cardPost {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.06);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
  }
  
  .card:hover,
  .cardPost:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2), 0 4px 8px rgba(0, 0, 0, 0.1);
  }
  
  .loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
  }
  
  .spinner {
    width: 50px;
    height: 50px;
    border: 5px solid #ccc;
    border-top: 5px solid #296080;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }
  
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
  
    100% {
      transform: rotate(360deg);
    }
  }

.card,
.cardPost {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.06);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.card:hover,
.cardPost:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2), 0 4px 8px rgba(0, 0, 0, 0.1);
}

.btn {
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transition: background-color 0.3s ease, box-shadow 0.3s ease;
}

.btn:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}


@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

.post-images-container img {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.post-images-container img:hover {
    transform: scale(1.05);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}

.btn-primary-soft {
    color: #296080;
    border: 1px solid #bbdefb;
}

.btn-primary-soft:hover {
    background-color: #296080;
    color: #fff;
    border: 1px solid #296080;
}

.post-images-container {
    margin-top: 15px;
}

.single-image img {
    width: 100%;
    height: auto;
}

.two-images img {
    width: 49%;
    height: auto;
}

.three-or-more-images {
    display: flex;
    flex-wrap: wrap;
}

.three-or-more-images .main-image img {
    width: 100%;
    height: 200px;
    object-fit: cover;
}

.three-or-more-images .other-images img {
    width: 49%;
    height: 100px;
    object-fit: cover;
    position: relative;
}

.three-or-more-images .overlay {
    position: absolute;
    top: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.5);
    color: #fff;
    font-size: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100px;
    width: 49%;
    z-index: 1;
}

.text-itkan {
    font-size: 25px;
    color: #ffffff;
}

.text-person {
    color: #296080;
}

.text-date {
    font-size: 10px;
    color: #2e2e2e;
}

.rounded-card {
    border-radius: 25px;
    overflow: hidden;
}

.carousel-item img {
    border-radius: 30px;
    height: 200px;
    object-fit: cover;
}


@media (max-width: 992px) {
    .card {
        border-radius: 0;
        box-shadow: none;
    }
}

.d-flex.flex-wrap.gap-2 button {
    padding: 0.5rem 1rem;
    font-size: 14px;
    border-radius: 10px;
    min-width: 120px;
    transition: all 0.3s ease;

}

.d-flex.flex-wrap.gap-2 button:hover {
    opacity: 0.8;
}

.profile-section {
    margin: 50px auto;
    max-width: 600px;
}

.card {
    background-color: #fff;
    border-radius: 15px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    margin-bottom: 25px;
}

.cardPost {
    background-color: #fff;
    border-radius: 15px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    margin-top: 5px;
}

.card-header {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #e9ecef;
    margin-bottom: 20px;
}

.card-body {
    margin: 10px 0;
    padding-bottom: 35px !important;
}

.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

.spinner {
    width: 50px;
    height: 50px;
    border: 5px solid #ccc;
    border-top: 5px solid #296080;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}


@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>